import { TooltipContent } from "../../InfoTooltip/TooltipModules";
import { TooltipHeader } from "../../InfoTooltip/TooltipModules";
import { InfoTooltip } from "../../InfoTooltip/InfoTooltip";
import React, { Fragment } from "react";

export const EnergyBreakdownTooltip = () => {
  const content = (
    <Fragment>
      <TooltipContent>
        The energy breakdown bar is a great way to see your school's total
        energy consumption in a flash. Look at how much of your school's energy
        is made up from the electricity grid and/or your solar system. And you
        can see if the solar panels have exported any unused energy back to the
        grid.
      </TooltipContent>
      <TooltipHeader>Check it out!</TooltipHeader>
      <TooltipContent>
        Let's see what happens when we click the 'Past 12 months' button to the
        left. Did the numbers change? Clicking these buttons will update the
        data displayed in the energy breakdown bar.
      </TooltipContent>
    </Fragment>
  );

  return <InfoTooltip content={content} />;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/tooltips/EnergyBreakdownTooltip.js